import { useEffect, useState } from "react";
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import { useDispatch } from "react-redux";
import {
  PaymentMethodList,
  GetWalletDataList,
} from "../../../services/ReduxTookit/Slice/InvoiceRedux";
import Loader, { LoaderType } from "../../../component/common-component/Loader";
import {
  commonservices,
  getCardBrandImage,
  getNormalisedBrandName,
} from "../../../services/CommonServices";
import Nodata from "../../../component/common-component/Nodata";
import moment from "moment";
import TopupModal from "./TopupModal";

const WalletManagement = ({ setShowRightPanel }) => {
  const dispatch = useDispatch();
  const [walletList, setWalletList] = useState([]);
  const [cardObjData, setCardObjData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showTopupModal, setShowTopupModal] = useState(false);
  const [PaymentMethodData, setPaymentMethodData] = useState(null);

  const fetchWalletDataList = async () => {
    setLoading(true);

    // // Fetch Payment Methods
    const bodyPaymentMethods = {};
    dispatch(PaymentMethodList(bodyPaymentMethods)).then((response) => {
      if (response?.payload?.isValidate) {
        let filteredpaymentMethod = response?.payload?.data?.data?.filter(
          (item) => item.isprimary
        );
        setPaymentMethodData(filteredpaymentMethod[0]);
      }
      if (!response?.payload?.isValidate) {
        setPaymentMethodData(null);
      }
    });

    dispatch(GetWalletDataList())
      .then((response) => {
        if (response?.payload?.isValidate) {
          setCardObjData({
            lastTransaction: moment(
              response?.payload?.data?.data?.dataList1?.[0]?.entrydate
            ).format("MMMM DD, YYYY"),
            walletAmount: response?.payload?.data?.data?.dataList1?.[0]?.amount,
            walletId: response?.payload?.data?.data?.dataList1?.[0]?.walletid,
          });

          setWalletList(response?.payload?.data?.data?.dataList2);
        }
        if (!response?.payload?.isValidate) {
          setWalletList([]);
          setCardObjData({
            lastTransaction: "-",
            walletAmount: 0,
            walletId: null,
          });
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchWalletDataList();
  }, []);

  return (
    <div className="bcm-main">
      <Row>
        <Col xl={4}>
          {loading ? (
            <Row>
              <Loader type={LoaderType.PaymentNextBilling} count={1} />
            </Row>
          ) : (
            <div className="common-white-bg bcmtop-main payment-method billing-listing-payment-method h-auto">
              <div className="payment-method-title">
                <h2>Last Transaction</h2>
              </div>
              <div className="payment-method-detail-billing mt-20">
                <h2>
                  {cardObjData?.lastTransaction && cardObjData?.lastTransaction}
                </h2>
              </div>
            </div>
          )}
        </Col>
        <Col xl={4}>
          <div className="common-white-bg bcmtop-main payment-method billing-listing-payment-method h-auto position-relative">
            <div className="payment-method-title">
              <h2>Wallet Balance</h2>
            </div>
            <div className="payment-method-detail-billing">
              <div className="payment-method-detail-billing-left">
                <div className="payment-method-detail-billing-price">
                  <p>
                    $
                    {cardObjData?.walletAmount
                      ? cardObjData?.walletAmount?.toFixed(2)
                      : 0}
                  </p>
                </div>
              </div>
              <div className="payment-method-detail-billing-right">
                <Button
                  className="button-topup"
                  onClick={() => setShowTopupModal(true)}
                >
                  Top-Up
                </Button>
              </div>
            </div>
          </div>
        </Col>
        <Col xl={4}>
          {loading ? (
            <Row>
              <Loader type={LoaderType.PaymentMethodSingleCard} count={1} />
            </Row>
          ) : (
            <div className="common-white-bg bcmtop-main payment-method billing-listing-payment-method h-auto">
              <div className="payment-method-title">
                <h2>Payment Method</h2>
                <p
                  className="cursor-pointer"
                  onClick={() => {
                    setShowRightPanel("paymentmethod");
                  }}
                >
                  Manage
                </p>
              </div>
              {PaymentMethodData ? (
                <div className="payment-method-detail">
                  <div className="payment-method-detail-img">
                    {PaymentMethodData?.display_brand &&
                      getCardBrandImage(PaymentMethodData?.display_brand)}
                  </div>
                  <div className="payment-method-detail-data">
                    <div className="visa-title ">
                      <h4>
                        {getNormalisedBrandName(
                          PaymentMethodData?.display_brand
                        )}{" "}
                        Ending with {PaymentMethodData?.methodnumber}{" "}
                      </h4>
                      <span className="cursor-pointer bg-success text-white">
                        <b>Primary</b>
                      </span>
                    </div>
                    <p>
                      Expires{" "}
                      {`${
                        PaymentMethodData?.exp_month
                      }/${PaymentMethodData?.exp_year?.substr(
                        PaymentMethodData?.exp_year?.length - 2,
                        PaymentMethodData?.exp_year?.length
                      )}`}
                    </p>
                  </div>
                </div>
              ) : (
                <small>Payment method not available.</small>
              )}
            </div>
          )}
        </Col>
      </Row>
      <div className="table-wrapper-main setting-table-main">
        <div className="profile-common-title"></div>
        <Table responsive>
          <thead>
            <tr>
              <th className="text-start">Date & Time</th>
              <th className="text-center">Amount</th>
              <th className="">Type</th>
              <th className="">Status</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <Loader type={LoaderType.TableRow} count={6} nooftd={5} />
            ) : (
              <>
                {walletList?.length > 0 ? (
                  <>
                    {walletList?.map((item) => {
                      return (
                        <tr key={item?.walletid}>
                          <td className="text-start">
                            {item?.entrydate
                              ? commonservices.getDateInFormatCustom(
                                  item?.entrydate,
                                  null,
                                  "MM/DD/YYYY, HH:mm"
                                )
                              : ""}
                          </td>
                          <td className="text-center">
                            {item?.amount > 0
                              ? `$${item?.amount?.toFixed(2)}`
                              : "$0"}
                          </td>
                          <td>{item?.transtype}</td>
                          <td>{commonservices.getStatus(item?.status)}</td>
                          <td>{item?.note}</td>
                        </tr>
                      );
                    })}
                  </>
                ) : (
                  <tr>
                    <td colSpan={100}>
                      <Nodata />
                    </td>
                  </tr>
                )}
              </>
            )}
          </tbody>
        </Table>
      </div>
      {showTopupModal && (
        <TopupModal
          walletId={cardObjData?.walletId}
          show={showTopupModal}
          onHide={(e) => setShowTopupModal(false)}
          onPaymentSuccess={fetchWalletDataList}
        />
      )}
    </div>
  );
};

export default WalletManagement;
